import { render, staticRenderFns } from "./newLogin.vue?vue&type=template&id=b24303ec&scoped=true&"
import script from "./newLogin.vue?vue&type=script&lang=js&"
export * from "./newLogin.vue?vue&type=script&lang=js&"
import style0 from "./newLogin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newLogin.vue?vue&type=style&index=1&id=b24303ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24303ec",
  null
  
)

export default component.exports